export enum LOCAL_STORAGE {
  NAVIGATION_URL = 'firstNavigationUrl',
  SELECTED_LANGUAGE = 'selectedLanguage',
  THEME_MENU_MODE_LS_KEY = 'kt_theme_mode_menu',
  SIDEBAR_MINIMIZE_ATTR = 'data-kt-app-sidebar-minimize',
  MOBILE_OFFCANVAS_CLASS = 'mobile-sidebar',
  SIDEBAR_MINIMIZE_STATE = 'sidebarMinimizeState',
  TABLE_COLUMN_WIDTHS_PREFIX = 'table-column-widths',
}
